export default __webpack_public_path__ + "static/media/icon_card_transportation.448bc389.svg";